import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledInput = styledComponent('input', {
  width: theme.sizes.checkboxSize,
  height: theme.sizes.checkboxSize,
  margin: 0,
  flexShrink: 0,
  cursor: 'pointer',
  accentColor: theme.colors.primary,
  '&:disabled': {
    cursor: 'not-allowed',
  },
  '&:focus-visible': {
    outline: 'none',
    boxShadow: `0 0 0 2px ${theme.colors.infoBlue}33`,
  },
});

function Checkbox({
  checked,
  indeterminate,
  disabled,
  onChange,
  'aria-label': ariaLabel,
  title,
  dataTestId,
}) {
  const inputRef = useRef(null);

  // `indeterminate` is a DOM-only property with no HTML attribute.
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <StyledInput
      ref={inputRef}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      aria-label={ariaLabel}
      title={title}
      data-testid={dataTestId}
    />
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  'aria-label': PropTypes.string,
  title: PropTypes.string,
  dataTestId: PropTypes.string,
};

Checkbox.defaultProps = {
  indeterminate: false,
  disabled: false,
  'aria-label': undefined,
  title: undefined,
  dataTestId: undefined,
};

export default Checkbox;
